import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    buttonContainer: {
      marginTop: 100
    },
    innerContainer: {
      [theme.breakpoints.down("sm")]: {
        order: 1,
        textAlign: "center"
      },
      display: "flex",
      flexDirection: "column",
      justifyContent: "center"
    },
    timeOutText: {
      marginTop: 40
    },
    notFoundImage: {
      width: "100%"
    },
    root: {
      alignItems: "center",
      display: "flex",
      height: "calc(100vh - 180px)",
      overflow: "hidden"
    },
    header: {
      marginBottom: theme.spacing(2)
    }
  }),
  { name: "ErrorPage" }
);

export default useStyles;
